import { ErrorHandler, OnInit } from '@angular/core'

import {
  AppContext,
  MergedExceptionHandler,
  SentryExceptionHandler
} from '../../../helpers'

export class AuthenticatedAppBase implements OnInit {

  constructor(
  protected _exceptionHandler: MergedExceptionHandler,
  protected _appContext: AppContext,
) {}

  public ngOnInit() {
    this.tryInitializeSentryUserInfo(this._exceptionHandler, this._appContext)
  }

  protected tryInitializeSentryUserInfo(exceptionHandler: MergedExceptionHandler, appContext: AppContext) {
    const validatedHandler = this._exceptionHandler
      .getHandlerInstance<SentryExceptionHandler>(SentryExceptionHandler)
    if (typeof validatedHandler !== 'undefined') {
      validatedHandler.addInfo('id', appContext.currentUser.id)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/authenticated-app-base/authenticated-app-base.ts